// extracted by mini-css-extract-plugin
export default {"scope":"b+f54","icon":"_4wsg-"};